import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { Card } from 'react-bootstrap';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import ClipLoader from 'react-spinners/ClipLoader';
import SeparateLine from '../../../Common/seperateLine';
import { getCustomers } from '../../../store/actions/customers';

const CustomerList = props => {
  const [customers, setCustomers] = useState([]);

  useEffect(() => {
    if (props.useSearch) {
      var filteredCustomers = props.useSearch.filterList(props.customers, 'customerName');
      setCustomers(filteredCustomers);
    }
  }, [props.useSearch, props.customers]);

  useEffect(() => {
    (async () => {
      if (_.isEmpty(props.customers)) {
        await props.fetchCustomers();
      }
    })();
  }, []);

  const sortCustomers = list => {
    let filterdUserGroupList = [];
    if (!_.isEmpty(list)) {
      list.forEach(element => {
        var firstNameAlphabets = element.customerName.substr(0, 1).toUpperCase();
        var existingAlphabetIdx = filterdUserGroupList.findIndex(element => element.title === firstNameAlphabets);
        if (existingAlphabetIdx > -1) {
          filterdUserGroupList[existingAlphabetIdx].data.push(element);
        } else {
          var userDataByAlphabetWise = { title: firstNameAlphabets, data: [] };
          userDataByAlphabetWise.data.push(element);
          filterdUserGroupList.push(userDataByAlphabetWise);
        }
      });
    }
    filterdUserGroupList.sort((a, b) => {
      if (a.title < b.title) {
        return -1;
      }
      if (a.title > b.title) {
        return 1;
      }
      return 0;
    });
    return filterdUserGroupList;
  };

  return (
    <>
      <Card.Body className="scrollable-card">
        <PerfectScrollbar style={{ height: window.innerHeight - 140 }}>
          {props.loading ? (
            <div className="d-flex" style={{ justifyContent: "center" }}>
              <ClipLoader color="#075978" />
            </div>
          ) : (
            sortCustomers(customers).map((customer, titlekey) => {
              return (
                <div key={titlekey}>
                  <div className="section-header">
                    <div>
                      <div>
                        <b>{customer.title}</b>
                      </div>
                    </div>
                  </div>
                  {customer.data.map((cus, key) => {
                    return (
                      <Link key={key} to={`/customer/${cus.id}`}>
                        <div
                          className={
                            !_.isEmpty(props.selectedCustomerId) && props.selectedCustomerId === cus.id.toString()
                              ? 'div-rec-select selected_row'
                              : 'div-rec-select'
                          }
                          onClick={() => props.menuset()}
                        >
                          <div className="py-0 pr-1 d-flex justify-content-between pointer">
                            <div className="p-2 mr-auto ">
                              <h6 className="mb-1">
                                <span className="pointer">{cus.customerName}</span>
                              </h6>
                            </div>
                          </div>
                          <SeparateLine className="mt-0 mb-0" />
                        </div>
                      </Link>
                    );
                  })}
                </div>
              );
            })
          )}
        </PerfectScrollbar>
      </Card.Body>
    </>
  );
};

const mapStateToProps = state => {
  return {
    customers: state.customers.customers,
    loading: state.customers.loading,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchCustomers: () => dispatch(getCustomers()),
    menuset: () => dispatch({ type: 'CUSTOMER' }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomerList);
